import { Button, Stack, TextField, Typography } from '@mui/material';
import { useFormik } from 'formik';
import { useEffect } from 'react';
import * as Yup from 'yup';
import useErrors from '../../../../hooks/useErrors';
import server from '../../../../services/server';
import { processAndSaveContractText } from '../../../../utils/processAndSaveContractText';

const DEFAULT_FIDELITY_MONTHS = 6;

/** Temporariamente oculto: valor da multa de fidelidade (voltar no futuro). */
const HIDE_FIDELITY_PENALTY = true;
const DEFAULT_PENALTY_VALUE = 0;

const schema = Yup.object().shape({
    months: Yup.number()
        .typeError('Informe o tempo de fidelidade')
        .required('Tempo de fidelidade é obrigatório')
        .min(1, 'Mínimo de 1 mês')
        .integer('Informe um número inteiro de meses'),
    // Temporariamente oculto — validação desativada enquanto HIDE_FIDELITY_PENALTY = true
    // penaltyValue: Yup.number()
    //     .typeError('Informe o valor da multa')
    //     .required('Valor da multa é obrigatório')
    //     .min(0, 'Valor não pode ser negativo'),
});

export function Fidelidade({ mutate, contract }) {
    const { setErrors, enqueueSnackbar } = useErrors();

    const { getFieldProps, setValues, isSubmitting, handleSubmit, handleBlur, errors, touched } =
        useFormik({
            initialValues: {
                months: DEFAULT_FIDELITY_MONTHS,
                penaltyValue: DEFAULT_PENALTY_VALUE,
            },
            validationSchema: schema,
            onSubmit: async (formValues, { setSubmitting }) => {
                try {
                    setSubmitting(true);
                    await server.put(`subscription/${contract.uuid}/fidelity`, {
                        months: Number(formValues.months),
                        penaltyValue: HIDE_FIDELITY_PENALTY
                            ? Number(formValues.penaltyValue ?? DEFAULT_PENALTY_VALUE)
                            : Number(formValues.penaltyValue),
                    });
                    await mutate?.();
                    await processAndSaveContractText(contract.uuid, { mutate });
                    setSubmitting(false);
                    enqueueSnackbar('Fidelidade do contrato salva.');
                } catch (error) {
                    setSubmitting(false);
                    setErrors(error);
                }
            },
        });

    useEffect(() => {
        if (!contract) return;

        const saved = contract.contractData?.fidelity;
        const months = contract.fidelityMonths ?? saved?.months ?? DEFAULT_FIDELITY_MONTHS;
        const penalty =
            contract.fidelityPenaltyValue ??
            (saved?.penaltyValue !== undefined && saved?.penaltyValue !== null
                ? saved.penaltyValue
                : DEFAULT_PENALTY_VALUE);

        setValues({
            months,
            penaltyValue: penalty,
        });
    }, [contract, setValues]);

    return (
        <Stack spacing={2}>
            <Typography variant="body2" color="text.secondary">
                Defina o período de fidelidade do contrato
                {!HIDE_FIDELITY_PENALTY && ' e o valor da multa em caso de rescisão antecipada'}.
            </Typography>

            <TextField
                label="Tempo de fidelidade (meses)"
                type="number"
                {...getFieldProps('months')}
                onBlur={handleBlur}
                fullWidth
                inputProps={{ min: 1, step: 1 }}
                error={touched.months && !!errors.months}
                helperText={touched.months && errors.months}
            />

            {/* Temporariamente oculto: valor da multa de fidelidade
            <TextField
                label="Valor da multa"
                {...getFieldProps('penaltyValue')}
                onBlur={handleBlur}
                fullWidth
                required
                error={touched.penaltyValue && !!errors.penaltyValue}
                helperText={(touched.penaltyValue && errors.penaltyValue) || 'Informe o valor da multa (pode ser R$ 0,00)'}
                InputProps={{
                    inputComponent: PriceInputMasked,
                }}
            />
            */}

            <Button
                variant="contained"
                sx={{ alignSelf: 'flex-end' }}
                onClick={handleSubmit}
                disabled={isSubmitting}
                loading={isSubmitting}
            >
                Salvar fidelidade
            </Button>
        </Stack>
    );
}
